import styled from 'styled-components';

export const Root = styled.div`
  background-color: ${({ theme }) => theme.backgroundColorMain};
  padding-left: 20px;
  padding-right: 20px;
  min-height: 100vh;
`;
